import { useMemo } from "react";

// Derives the SummaryStats numbers from /get-assigned-dbs.
//
//   Total       = tabs.TP.count                 (or fallback: data.TP.length)
//   Assigned    = sum of cp_db_id !== '' && !== 'MISROUTE' across data.TP
//   Remaining   = Total − Assigned
//   DBsFilled   = count(cp_db with at least one assigned customer)
//   TotalDbs    = cp_dbs.length

const useSummaryStats = (data) =>
  useMemo(() => {
    const cpDbs = Array.isArray(data?.cp_dbs) ? data.cp_dbs : [];
    const tps = Array.isArray(data?.data?.TP) ? data.data.TP : [];

    const total = Number(data?.tabs?.TP?.count) || tps.length || 0;

    // Build assigned-tp-count per cp_db_id from the TP list.
    const assignedByDb = new Map();
    let assigned = 0;
    tps.forEach((customer) => {
      const ud = (customer?.tp_list || [])[0];
      const dbId = ud?.cp_db_id;
      const status = ud?.status;
      if (
        dbId &&
        dbId !== "MISROUTE" &&
        dbId !== "UNASSIGN" &&
        status === "ASSIGNED"
      ) {
        assigned += 1;
        assignedByDb.set(dbId, (assignedByDb.get(dbId) || 0) + 1);
      }
    });

    const remaining = Math.max(0, total - assigned);
    const totalDbs = cpDbs.length;

    let dbsFilled = 0;
    cpDbs.forEach((db) => {
      const assignedForDb = assignedByDb.get(db?.cp_db_id) || 0;
      if (assignedForDb > 0) dbsFilled += 1;
    });

    return {
      total,
      assigned,
      remaining,
      dbsFilled,
      totalDbs,
      assignedByDb,
    };
  }, [data]);

export default useSummaryStats;
